import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { RequireAuth } from '../components/auth/RequireAuth';

const LoginPage = lazy(() => import('../pages/login/page'));
const IPAnalysisPage = lazy(() => import('../pages/ip-analysis/page'));
const ContentEnginePage = lazy(() => import('../pages/content-engine/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ActivityPlazaPage = lazy(() => import('../pages/activity-plaza/page'));
const MyRegistrationsPage = lazy(() => import('../pages/my-registrations/page'));
const EventRegistrationsPage = lazy(() => import('../pages/event-registrations/page'));
const SocialPage = lazy(() => import('../pages/social/page'));
const UserProfilePage = lazy(() => import('../pages/user-profile/page'));
const ScriptAnalysisPage = lazy(() => import('../pages/script-analysis/page'));
const ContentProjectsPage = lazy(() => import('../pages/content-projects/page'));
const BgmLibraryPage = lazy(() => import('../pages/bgm-library/page'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <ActivityPlazaPage />,
  },
  {
    path: '/ip-analysis',
    element: (
      <RequireAuth>
        <IPAnalysisPage />
      </RequireAuth>
    ),
  },
  {
    path: '/content',
    element: (
      <RequireAuth>
        <ContentEnginePage />
      </RequireAuth>
    ),
  },
  {
    path: '/content/projects',
    element: (
      <RequireAuth>
        <ContentProjectsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/content/project/:projectId',
    element: (
      <RequireAuth>
        <ContentEnginePage />
      </RequireAuth>
    ),
  },
  {
    path: '/script-analysis',
    element: (
      <RequireAuth>
        <ScriptAnalysisPage />
      </RequireAuth>
    ),
  },
  {
    path: '/events',
    element: (
      <RequireAuth>
        <EventsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/analytics',
    element: (
      <RequireAuth>
        <AnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/settings',
    element: (
      <RequireAuth>
        <SettingsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/activity-plaza',
    element: <ActivityPlazaPage />,
  },
  {
    path: '/my-registrations',
    element: (
      <RequireAuth>
        <MyRegistrationsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/events/:id/registrations',
    element: (
      <RequireAuth>
        <EventRegistrationsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/social',
    element: (
      <RequireAuth>
        <SocialPage />
      </RequireAuth>
    ),
  },
  {
    path: '/users/:id',
    element: (
      <RequireAuth>
        <UserProfilePage />
      </RequireAuth>
    ),
  },
  {
    path: '/bgm-library',
    element: (
      <RequireAuth>
        <BgmLibraryPage />
      </RequireAuth>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
